<script>
import { mapActions, mapGetters } from 'vuex'
import LABELS from '@/constants/labels'
import { LAYOUT } from '@/constants/enum'
import { templateList, backgroundTable } from '@/constants/data'

export default {
  name: 'SelectLayout',
  data() {
    return {
      data: [
        {
          src: 'images/base/landscape.png',
          name: 'MINTIA タイプ',
          id: LAYOUT.LANDSCAPE,
        },
        {
          src: 'images/base/portraid.png',
          name: 'MINTIA BREEZE タイプ',
          id: LAYOUT.PORTRAID,
        },
      ],
      currentSelect: '',
      currentDataSelect: '',
    }
  },
  computed: {
    ...mapGetters('settings', ['getOrientation']),
    mappingLabels() {
      return LABELS
    },
  },
  methods: {
    ...mapActions('settings', [
      'setOrientation',
      'saveToStorage',
      'setTemplate',
      'setModules',
    ]),
    handleChooseLable(id) {
      this.currentSelect = id
    },
    handleNextStep() {
      this.setOrientation(this.currentSelect)
      this.currentDataSelect = {
        tabId: templateList[this.currentSelect][0].id,
        template: templateList[this.currentSelect][0].templates[0],
      }

      this.setTemplate({
        tabId: this.currentDataSelect.tabId,
        templateId: this.currentDataSelect.template.id,
      })
      this.setModules({
        data: {
          background:
            backgroundTable.find(
              bg => bg.id === this.currentDataSelect.template.bgId
            ) || '',
          avatars: this.currentDataSelect.template.avatars,
          stamps: this.currentDataSelect.template.stamps,
          texts: this.currentDataSelect.template.texts,
        },
      })
      this.saveToStorage()
      this.$router.push({ name: 'preview' })
    },
  },
  mounted() {
    if (this.getOrientation) {
      this.currentSelect = this.getOrientation
    } else {
      this.currentSelect = LAYOUT.LANDSCAPE
    }
  },
}
</script>

<template>
  <div>
    <s-header>{{ mappingLabels.layoutTitle }}</s-header>
    <div class="select-layout">
      <div class="select-layout__body">
        <div
          class="select-layout__item"
          v-for="item of data"
          :key="item.id"
          :class="{
            active: currentSelect && currentSelect === item.id,
          }"
          @click="handleChooseLable(item.id)"
        >
          <div class="select-layout__content">
            <div class="select-layout__img">
              <div class="image">
                <img :src="item.src" :alt="item.name" />
              </div>
            </div>
            <div class="select-layout__name">
              {{ item.name }}
            </div>
          </div>
          <div
            class="select-layout__tick"
            v-if="currentSelect && currentSelect === item.id"
          >
            <x-icon-tick />
          </div>
        </div>
      </div>
      <s-navigate-bar
        @leftClick="$router.push({ name: 'home' })"
        @rightClick="handleNextStep"
        >{{ mappingLabels.nextText }}</s-navigate-bar
      >
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import 'selectLayout.scss';
</style>
